import React from 'react';

const About: React.FC = () => (
  <main className="main-content page-enter">
    <section className="about-section">
      <h2 className="tag-line">Über mich</h2>

      <article className="about-content about-article">
        <h3 className="about-title">Warum ich Politik mache</h3>

        <p className="lead">
          Ich bin 1993 in Winterthur geboren. Mein Lebenslauf liest sich heute geradlinig: Gymnasium,
          Studium, Job als Data Scientist. Doch der Weg dorthin war geprägt von Brüchen. Als jemand,
          der einst von der Schule flog, weiss ich aus eigener Erfahrung, wie wenig unser Bildungssystem
          für bewegungsfreudige, energiegeladene Jugendliche taugt – und genau diese Perspektive treibt
          mich heute in der Politik an.
        </p>

        <h4>Ein Schulsystem, das Energie bestraft statt kanalisiert</h4>
        <p>
          Meine politische Prägung begann nicht in einer Jungpartei, sondern durch den Ausschluss aus der
          Volksschule. Ich erlebte ein starr ausgerichtetes System, das zunehmend auf lückenlose
          Disziplinierung und die bürokratische Dokumentation kleinster Regelverstösse setzt. Wer den
          Rahmen durch Tatendrang und Lebhaftigkeit sprengt, wird schnell dauerhaft stigmatisiert.
        </p>

        <p>
          Wir müssen den Tatsachen ins Auge sehen: Die heutige Volksschule verwechselt Bewegungsdrang oft
          mit einer Verhaltensstörung. Anstatt die immense Energie von Jugendlichen produktiv zu nutzen,
          vermittelt das System ihnen das Gefühl, keinen Platz in dieser Gesellschaft zu haben. Ist man
          durch ein unflexibles Eintragsheft erst einmal für das restliche Semester abgestempelt, fehlt
          oft jede Perspektive zur Besserung.
        </p>

        <h4>Die unsichtbaren Folgen: Psychische Not und Sucht</h4>
        <p>
          Die permanente Abwertung im Schulalltag hinterlässt tiefe Spuren. Wenn junge Menschen
          systematisch ausgegrenzt werden, steigen die Risiken für psychische Krisen und
          Suchterkrankungen massiv an. Viele Schüler greifen zu Substanzen, weil das Schulsystem
          kein anderes Ventil lässt — ein schleichender Einstieg in die Abhängigkeit, der sich durch
          frühe Auffangstrukturen verhindern liesse. Ich weiss das nicht aus Studien. Ich weiss es
          aus eigener Erfahrung.
        </p>

        <h4>Der Wendepunkt: Raum für Bewegung und Selbstvertrauen</h4>
        <p>
          Dass mein Weg trotz des Schulverweises schliesslich in die Wissenschaft führte, verdanke ich
          alternativen Ansätzen wie dem Timeoutprojekt „Trampolin". Weg von der sturen Schulbank, hin zu
          handwerklicher Arbeit, Sport und einem Unterricht, der Bewegung zuliess. Hier ging es nicht um
          permanentes Stillsitzen, sondern darum, über Aktivität wieder Selbstvertrauen zu tanken und
          echte Selbstwirksamkeit zu erfahren.
        </p>

        <h4>Wofür ich heute kämpfe</h4>
        <p>
          Heute beobachte ich eine besorgniserregende Dynamik: Lebhaftigkeit und die biologischen
          Entwicklungsbedürfnisse von Knaben werden in der Bildungsdebatte oft pauschal als Problem
          oder gar als „toxisch" abgetan. Die spezifischen Bedürfnisse von Knaben und jungen Männern
          werden politisch ignoriert — nicht aus bösem Willen, sondern weil niemand sie systematisch
          zum Thema macht. Ich trete an, weil ich das ändern will.
        </p>

        <p>
          Die Schulgeschichte war mein Einstieg. Aber je mehr ich mich mit dem Thema beschäftigte,
          desto klarer wurde: Das Bildungssystem ist nur ein Ausschnitt. Männer sind in der Schweiz
          überproportional von Suizid, Obdachlosigkeit, Sucht und sozialer Isolation betroffen —
          und die Sozialpolitik reagiert darauf kaum. Nicht weil die Daten fehlen, sondern weil
          die politische Kategorie „Mann in der Krise" schlicht nicht existiert. Das ist das eigentliche
          Problem, das diese Website adressieren will.
        </p>

        <h4>Ich engagiere mich für:</h4>
        <ul className="about-list">
          <li>
            <strong>Ein biologisch informiertes Bildungssystem:</strong> Schule muss die
            unterschiedlichen Entwicklungsverläufe von Knaben und Mädchen anerkennen — nicht
            wegdisziplinieren.
          </li>
          <li>
            <strong>Evidenzbasierte Prävention:</strong> Sucht und psychische Krisen bei Männern
            haben neurobiologische Wurzeln, die ein Gesundheitssystem ohne Männermedizin systematisch
            übersieht.
          </li>
          <li>
            <strong>Strukturelle Gleichstellung:</strong> Wehrpflicht, Vaterschaftsurlaub,
            Rentenrecht — es gibt konkrete gesetzliche Asymmetrien, die sich ändern lassen.
          </li>
          <li>
            <strong>Wertschätzung statt Pathologisierung:</strong> Eine Gesellschaft, die die
            Energie und den Gestaltungswillen von Männern als Ressource begreift statt als
            Risiko, ist besser für alle.
          </li>
        </ul>
      </article>
    </section>
  </main>
);

export default About;
